import React, { useEffect, useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import tick_white from "../../assets/images/tick_white.png";
import options from "../../constants";
import Header from "../../layouts/header";
import { useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { ThreeDots } from "react-loader-spinner";
import { toast } from "react-toastify";
import { buildApiUrl } from "../../config/api";

const submitData = async (
  values,
  props,
  isSubmit = false,
  setPostLoading,
  navigate,
  moveStep = true,
  location,
  token,
  clientId,
  params
) => {
  setPostLoading(true);

  const requestBody = {
    ...values,
    clientId,
    API_key: process.env.REACT_APP_API_KEY,
  };

  try {
    const response = await fetch(buildApiUrl(`api/add_info_multistep?params=${params}`), {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(requestBody),
    });

    const resData = await response.json();

    if (!response.ok) {
      throw new Error(resData?.error || resData?.message || "Request failed");
    }

    if (isSubmit) {
      const updateResponse = await fetch(buildApiUrl(`api/course_first_updation?params=${params}`), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          API_key: process.env.REACT_APP_API_KEY,
          clientId,
          video: "7",
        }),
      });

      const updateData = await updateResponse.json();

      if (!updateResponse.ok) {
        throw new Error(updateData?.error || updateData?.message || "Update failed");
      }

      setPostLoading(false);
      navigate(`/course1/${clientId}`);
      props.next(values);
      return;
    }

    setPostLoading(false);
    if (moveStep) {
      props.next(values);
    }
  } catch (err) {
    toast.error(err.message || "Something went wrong");
    setPostLoading(false);
  }
};

const Step1 = (props) => {
  const user = useSelector((state) => state.user);
  const location = useLocation();
  const navigate = useNavigate();
  const { clientId, token, params } = props;
  const [postLoading, setPostLoading] = useState(false);

  const handleSubmit = (values) => {
    submitData(values, props, false, setPostLoading, navigate, true, location, token, clientId, params);
  };

  return (
    <Formik initialValues={props.data} onSubmit={handleSubmit}>
      {({ submitForm, values }) => (
        <Form>
          <div className="Budget_Analysis mt-60">
            <h1 className="title">Budget <span className="text_success">Analysis</span></h1>
            <div className="step_progress_bar mt-60">
              <ul>
                <li className="active-step">1</li>
                <li>2</li>
                <li>3</li>
                <li>4</li>
                <li>5</li>
                <li>6</li>
                <li>7</li>
                <li>8</li>
                <li>9</li>
                <li>10</li>
                <li>11</li>
                <li>12</li>
                <li>13</li>
              </ul>
            </div>
            <div className="head mt-60">
              <h1 className="f18">Account Details</h1>
            </div>
            <div className="row">
              <div className="col-lg-6">
                <div className="form-group mt-40">
                  <label className="label-title" htmlFor="householdSize">How many people do you have in your household?</label>
                  <Field name="householdSize" type="number" className="form-control" />
                  <ErrorMessage name="householdSize" component="div" className="text-danger" />
                </div>
              </div>
            </div>
            <div className="d-flex justify-content-end mt-40">
              <button type="submit" className="btn_brnd" disabled={postLoading}>
                {postLoading ? <ThreeDots height="20" width="40" color="#fff" /> : "Next"}
              </button>
            </div>
          </div>
        </Form>
      )}
    </Formik>
  );
};

const AddInfoMultistepThirdParty = ({ token = null, clientId = null, params = null }) => {
  const navigate = useNavigate();
  const [step, setStep] = useState(1);
  const [data, setData] = useState({
    householdSize: "",
  });

  const nextStep = (values) => {
    setData((prev) => ({ ...prev, ...values }));
    setStep((prev) => prev + 1);
  };

  const prevStep = () => setStep((prev) => prev - 1);

  const handleSubmit = (values) => {
    const location = window.location;
    submitData(values, { next: () => navigate(`/course1/${clientId}`), user: { user: { data: {} } } }, true, () => {}, navigate, false, location, token, clientId, params);
  };

  const renderStep = () => {
    switch (step) {
      case 1:
        return <Step1 data={data} next={nextStep} clientId={clientId} token={token} params={params} />;
      default:
        return <div className="text-center py-5"><p>Completed</p></div>;
    }
  };

  return (
    <div>
      <Header />
      {renderStep()}
    </div>
  );
};

export default AddInfoMultistepThirdParty;
